// Fragments appear one by one; no easing, the stagger is the whole animation.
export function getTextTypewriterAnimation () {
    return {
        instant: true,
        ease: 'none',
        from: { opacity: 0 },
    }
}
